import React, { memo } from 'react'
import { Row, Col, Button } from 'react-bootstrap'
import { PPCManagmentModalConfig } from './config'
const { DRAFT_STATUS, REVIEW_STATUS } = PPCManagmentModalConfig

const BidModalButtons = ({
    campaign,
    inventoryCampaign,
    innitialInventoryCampaign,
    language,
    ppc_modal_labels,
    estimateIsLoading,
    handleSave,
    handleSubmitBid,
    handleWithdrawBid,
    disabled
}) => {
    const status = inventoryCampaign?.inventory_campaign_status
    const labels = ppc_modal_labels[language]

    if (status !== DRAFT_STATUS && status !== REVIEW_STATUS) {
        const isChanged =
            innitialInventoryCampaign?.cpc !== inventoryCampaign?.cpc ||
            innitialInventoryCampaign?.custom_url !== inventoryCampaign?.custom_url ||
            innitialInventoryCampaign?.ppc_bid_active !== inventoryCampaign?.ppc_bid_active ||
            innitialInventoryCampaign?.img_lg !== inventoryCampaign?.img_lg ||
            innitialInventoryCampaign?.img_sm !== inventoryCampaign?.img_sm ||
            innitialInventoryCampaign?.custom_url !== inventoryCampaign?.custom_url ||
            innitialInventoryCampaign?.tagline !== inventoryCampaign?.tagline ||
            innitialInventoryCampaign?.custom_description !== inventoryCampaign?.custom_description ||
            innitialInventoryCampaign?.content_type !== inventoryCampaign?.content_type

        const variant = isChanged ? 'primary' : 'outline-primary'

        const label =
            innitialInventoryCampaign?.cpc !== inventoryCampaign?.cpc
                ? inventoryCampaign?.ppc_bid_active
                    ? labels.set_bid
                    : labels.save_bid_inactive
                : labels.save

        return (
            <Button id="bid-modal-save" variant={variant} className="block w-100 mt-3" onClick={handleSave} disabled={disabled}>
                {label}
            </Button>
        )
    }

    if (status === DRAFT_STATUS) {
        return (
            <Row className="g-2">
                <Col sm="12">
                    <Button
                        id="bid-modal-save"
                        variant="primary"
                        className="block w-100 mt-3"
                        onClick={handleSubmitBid}
                        disabled={inventoryCampaign?.ppc_bid_active === false || !campaign?.ppc_active || estimateIsLoading}
                    >
                        {labels.submit_bid}
                    </Button>
                </Col>
            </Row>
        )
    }

    if (status === REVIEW_STATUS) {
        return (
            <Row className="g-2">
                <Col sm="6">
                    <Button id="bid-modal-save" variant="outline-primary" className="block w-100 mt-3" onClick={handleSave} disabled={disabled}>
                        {labels.save}
                    </Button>
                </Col>
                <Col sm="6">
                    <Button
                        id="bid-modal-withdraw"
                        variant="danger"
                        className="block w-100 mt-3"
                        onClick={handleWithdrawBid}
                        disabled={!campaign?.ppc_active || estimateIsLoading}
                    >
                        {labels.withdraw_bid}
                    </Button>
                </Col>
            </Row>
        )
    }

    return null
}

export default memo(BidModalButtons)
